import { createSlice } from '@reduxjs/toolkit'
import playerService from '../services/players'

const playerSlice = createSlice({
  name: 'players',
  initialState: {
    myPlayers: [], // Oma pelaajaluettelo (MyPlayers)
    myPlayersLoaded: false, // Onko oma lista ladattu
    playerCache: {}, // Yksittäisten pelaajien cache: { playerId: playerData }
  },
  reducers: {
    appendPlayer(state, action) {
      state.myPlayers.push(action.payload)
    },
    removePlayer(state, action) {
      const idToRemove = String(action.payload)
      state.myPlayers = state.myPlayers.filter(
        p => String(p.id || p.playerId) !== idToRemove
      )
      if (state.playerCache[idToRemove]) {
        delete state.playerCache[idToRemove]
      }
    },
    setMyPlayers(state, action) {
      state.myPlayers = action.payload
      state.myPlayersLoaded = true
    },
    cachePlayer(state, action) {
      const player = action.payload
      const cacheKey = player.isCustom ? player.id : player.playerId
      if (cacheKey) {
        state.playerCache[String(cacheKey)] = player
      }
    },
    clearPlayerCache(state) {
      state.playerCache = {}
    },
    resetPlayers() {
      return {
        myPlayers: [],
        myPlayersLoaded: false,
        playerCache: {},
      }
    },
  },
})

export const {
  appendPlayer,
  removePlayer,
  setMyPlayers,
  cachePlayer,
  clearPlayerCache,
  resetPlayers,
} = playerSlice.actions

export const initializePlayers = id => {
  return async (dispatch, getState) => {
    const { players } = getState()
    // Jos pelaajat on jo ladattu, käytetään cachea
    if (players.myPlayersLoaded) {
      return players.myPlayers
    }
    const playerList = await playerService.getAll(id)
    dispatch(setMyPlayers(playerList))
    return playerList
  }
}

/**
 * Hakee yksittäisen pelaajan. Etsii ensin myPlayers-listasta,
 * sitten playerCachesta, ja vasta sitten backendistä.
 */
export const fetchPlayer = (playerId, userId) => {
  return async (dispatch, getState) => {
    const { players } = getState()
    // 1. Etsi ensin omasta pelaajaluettelosta
    const fromMyPlayers = players.myPlayers.find(
      p =>
        String(p.playerId) === String(playerId) ||
        String(p.id) === String(playerId)
    )
    if (fromMyPlayers) {
      return fromMyPlayers
    }
    // 2. Etsi playerCachesta
    if (players.playerCache[playerId]) {
      return players.playerCache[playerId]
    }
    // 3. Hae backendistä ja tallenna cacheen
    const player = await playerService.getOnePlayer(playerId, userId)
    if (player) {
      dispatch(cachePlayer(player))
    }
    return player
  }
}

export const createPlayer = content => {
  return async dispatch => {
    const newPlayer = await playerService.create(content)
    dispatch(appendPlayer(newPlayer))
  }
}

export const createCustomPlayer = (content, oauthToken) => {
  return async dispatch => {
    const newPlayer = await playerService.createCustom(content, oauthToken)
    dispatch(appendPlayer(newPlayer))
    return newPlayer
  }
}

export const deleteCustomPlayer = (customPlayerId, oauthToken) => {
  return async dispatch => {
    await playerService.deleteCustom(customPlayerId, oauthToken)
    dispatch(removePlayer(customPlayerId))
  }
}

export default playerSlice.reducer
